import React from "react";
import { IIcon } from "./Icon.types";

const VolumeIcon: React.FC<IIcon> = ({
  width= "36",
  height= "36",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="volumeIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6.99999C16 6.58797 15.5296 6.35278 15.2 6.59999L8 12H5C4.44772 12 4 12.4477 4 13V19C4 19.5523 4.44772 20 5 20H8L15.2 25.4C15.5296 25.6472 16 25.412 16 25V6.99999ZM19.634 11.1699C19.9101 10.6916 20.5217 10.5277 21 10.8038C21.9121 11.3305 22.6695 12.0879 23.1962 13C23.7228 13.9121 24 14.9468 24 16C24 17.0532 23.7228 18.0879 23.1962 19C22.6695 19.9121 21.9121 20.6695 21 21.1961C20.5217 21.4723 19.9101 21.3084 19.634 20.8301C19.3578 20.3518 19.5217 19.7402 20 19.4641C20.6081 19.113 21.113 18.6081 21.4641 18C21.8152 17.3919 22 16.7021 22 16C22 15.2978 21.8152 14.6081 21.4641 14C21.113 13.3919 20.6081 12.887 20 12.5359C19.5217 12.2597 19.3578 11.6482 19.634 11.1699ZM23 7.33974C22.5217 7.0636 21.9101 7.22747 21.634 7.70576C21.3578 8.18406 21.5217 8.79565 22 9.07179C23.2162 9.77394 24.2261 10.7838 24.9282 12C25.6304 13.2161 26 14.5957 26 16C26 17.4043 25.6304 18.7838 24.9282 20C24.2261 21.2161 23.2162 22.226 22 22.9282C21.5217 23.2043 21.3578 23.8159 21.634 24.2942C21.9101 24.7725 22.5217 24.9364 23 24.6602C24.5202 23.7826 25.7826 22.5202 26.6603 21C27.5379 19.4798 28 17.7554 28 16C28 14.2446 27.5379 12.5202 26.6603 11C25.7826 9.4798 24.5202 8.21742 23 7.33974Z"
        fill="white"
      />
    </svg>
  );
};

export default VolumeIcon;
